<template>
  <div>
    <label
      v-if="label !== ''"
      class="block text-sm font-medium leading-5 text-gray-700"
    >{{ label }}</label>
    <div
      class="mt-1 relative rounded-md shadow-sm"
      :class="addOn !== '' ? 'flex' : ''"
    >
      <span
        v-if="addOn !== ''"
        class="inline-flex items-center px-3 rounded-l-md border border-r-0 text-gray-500 sm:text-sm"
        :class="addOnBorder ? 'border-gray-300 bg-gray-50' : 'pr-1' "
      >
        {{ addOn }}
      </span>
      <input
        v-model="input"
        class="form-input block w-full sm:text-sm sm:leading-5"
        :type="type"
        :class="inputClasses"
        :placeholder="placeholder"
        aria-invalid="true"
        aria-describedby="email-error"
      >
      <span
        v-if="tag !== ''"
        class="inline-flex items-center px-3 pr-2 rounded-r-md border border-l-0 text-gray-500 sm:text-sm"
        :class="addOnBorder ? 'border-gray-300 bg-gray-50' : 'pr-1' "
      >
        {{ tag }}
      </span>
      <div
        v-if="showValidation"
        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
      >
        <svg
          class="h-5 w-5 text-red-500"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
    <p
      v-if="showValidation"
      id="email-error"
      class="mt-2 text-sm text-red-600"
    >
      Your password must be less than 4 characters.
    </p>
  </div>
</template>

<script>
export default {

  props: {
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: '',
    },
    addOn: {
      type: String,
      default: '',
    },
    addOnBorder: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      input: '',
      showValidation: false,
    };
  },

  computed: {
    inputClasses() {
      let classes = '';
      if (this.addOn) {
        classes += 'flex-1 px-3 py-2 rounded-none ';
        if (!this.addOnBorder) {
          classes += 'border-l-0 pl-1 ';
        }
      }

      if (this.tag !== '') {
        classes += 'border-r-0 pr-1 ';
      } else {
        classes += 'rounded-r-md ';
      }

      return classes;
    },
  },

  watch: {
    input() {
      this.$emit('change', this.input);
    },
  },

  mounted() {
    this.input = this.value;
  },

};
</script>
